export const parseUrlQuery = query => {
	return query
		.replace( '?', '' )
		.split( '&' )
		.reduce( ( acc, item ) => {
			const split = item.split( '=' );

			return {
				...acc,
				[ split[ 0 ] ]: split[ 1 ]
			};
		}, {} );
};
